module.exports = __webpack_public_path__ + "static/media/GateApp.ce7ae12f.png";